import React from 'react';

const Blog = () => {
  return (
    <div className="page">
      <h1>Blog</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Blog; 